export * from "../../types"

import { omnia } from "@omnia/exports/omnia"

export const {
    convertDatesToJsonUtc,
    createLookup,
    crops,
    defineComponent,
    defineDirective,
    handleApiError,
    isAdmin,
    isArrayEmpty,
    isNumber,
    isUndefinedOrNull,
    labels,
    models,
    omniaResolve,
    OmniaService,
    param,
    setDates,
    shell,
    str,
    sum,

    fields: {
        getCropColor,
        getCropCssColor
    },

    color: {
        changeLuminosity,
        colorToCss,
        getWhiteBlackForegroundFromBackgroundColor
    },

    manure: {
        getManureTypeColor,
        filterAvailableTypes,
        setupManureTypesForRegion
    },

    stocks: {
        manureStockAnalysisFields,
        manureStockTotalFields
    },

    nutrition

} = omnia

export { Module } from "@omnia/shared/shell/module"

export {
    OmniaModuleId,
    OmniaObjectType,
    StockType,
    RegionId
} from "@omnia/shared/generated/enums"